import { Col, Divider, Input, Row, Select, Space } from "antd";

import styles from "./AddressInformation.module.css";
import { useTranslation } from "react-i18next";
import { FormInput, FormSelect } from "components/form/FormProvide";

const AddressInformationForEdit = ({
  lower = null,
  provinceOptionsTh = [],
  provinceOptionsEn = [],
  districtOptionsTh = [],
  districtOptionsEn = [],
  subDistrictOptionsTh = [],
  subDistrictOptionsEn = [],
  onProviceChange = () => { },
  onDistrictChange = () => { },
  onSubDistrictChange = () => { },
}) => {
  const { t } = useTranslation();

  return (
    <Space direction="vertical" size={6}>
      <b className={styles.infoTopic}>
        {t("company_profile.label.address_information")}
      </b>
      <Divider />
      <Row gutter={[24, 16]}>
        <Col span={24}>
          <FormInput
            fontWeight="bold"
            vertical={true}
            required
            name="address"
            label={
              t("company_profile.label.address_th")
            }
            placeholder={t('company_profile.label.address_detail_th')}
            size="large"
          />
        </Col>
        <Col span={6}>
          <FormSelect
            fontWeight="bold"
            vertical={true}
            required
            name="provinceId"
            label={t("address.province")}
            placeholder={t('company_profile.label.please_select')}
            size="large"
            options={provinceOptionsTh}
            onChange={onProviceChange}
          />
        </Col>
        <Col span={6}>
          <FormSelect
            fontWeight="bold"
            vertical={true}
            required
            name="districtId"
            label={t("address.district")}
            placeholder={t('company_profile.label.please_select')}
            size="large"
            options={districtOptionsTh}
            onChange={onDistrictChange}
          />
        </Col>
        <Col span={6}>
          <FormSelect
            fontWeight="bold"
            vertical={true}
            required
            name="subdistrictId"
            label={t("address.subdistrict")}
            placeholder={t('company_profile.label.please_select')}
            size="large"
            options={subDistrictOptionsTh}
            onChange={onSubDistrictChange}
          />
        </Col>
        <Col span={6}>
          <FormInput
            fontWeight="bold"
            vertical={true}
            required
            name="zipCode"
            label={t("address.postal_code")}
            placeholder={t('company_profile.label.please_select')}
            size="large"
            maxLength={5}
          />
        </Col>
        <Col span={24}>
          <FormInput
            fontWeight="bold"
            vertical={true}
            required
            name="addressEn"
            label={
              t("company_profile.label.address_en")
            }
            size="large"
          />
        </Col>
        <Col span={6}>
          <FormSelect
            fontWeight="bold"
            vertical={true}
            required
            name="provinceId"
            label={t("address.province")}
            placeholder={t('company_profile.label.please_select')}
            size="large"
            options={provinceOptionsEn}
            onChange={onProviceChange}
          />
        </Col>
        <Col span={6}>
          <FormSelect
            fontWeight="bold"
            vertical={true}
            required
            name="districtId"
            label={t("address.district")}
            placeholder={t('company_profile.label.please_select')}
            size="large"
            options={districtOptionsEn}
            onChange={onDistrictChange}
          />
        </Col>
        <Col span={6}>
          <FormSelect
            fontWeight="bold"
            vertical={true}
            required
            name="subdistrictId"
            label={t("address.subdistrict")}
            placeholder={t('company_profile.label.please_select')}
            size="large"
            options={subDistrictOptionsEn}
            onChange={onSubDistrictChange}
          />
        </Col>
        <Col span={6}>
          <FormInput
            fontWeight="bold"
            vertical={true}
            required
            name="zipCode"
            label={t("address.postal_code")}
            placeholder={t('company_profile.label.please_select')}
            size="large"
            maxLength={5}
          />
        </Col>
      </Row>
      {lower}
    </Space>
  );
};

export default AddressInformationForEdit;
